var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRoundDateRange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 6.66659H30V4.99992C30 4.08325 29.25 3.33325 28.3333 3.33325C27.4167 3.33325 26.6667 4.08325 26.6667 4.99992V6.66659H13.3333V4.99992C13.3333 4.08325 12.5833 3.33325 11.6667 3.33325C10.75 3.33325 10 4.08325 10 4.99992V6.66659H8.33333C6.48333 6.66659 5.01667 8.16658 5.01667 9.99992L5 33.3333C5 34.2173 5.35119 35.0652 5.97631 35.6903C6.60143 36.3154 7.44928 36.6666 8.33333 36.6666H31.6667C33.5 36.6666 35 35.1666 35 33.3333V9.99992C35 8.16658 33.5 6.66659 31.6667 6.66659ZM31.6667 31.6666C31.6667 32.5833 30.9167 33.3333 30 33.3333H10C9.08333 33.3333 8.33333 32.5833 8.33333 31.6666V14.9999H31.6667V31.6666ZM11.6667 18.3333H15V21.6666H11.6667V18.3333ZM18.3333 18.3333H21.6667V21.6666H18.3333V18.3333ZM25 18.3333H28.3333V21.6666H25V18.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundDateRange);
export default __webpack_public_path__ + "static/media/ic_round-date-range.02888daa3675471f25c054119093cc76.svg";
export { ForwardRef as ReactComponent };